<template>
  <section v-if="!isLoading" class="mt-2 overflow-x-auto">
    <table class="w-full border rounded-lg divide-y divide-gray-200 text-xs">
      <thead class="bg-gray-100">
        <tr>
          <th class="p-2 text-center">№</th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Үйлдэл" : "Action" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Уулзалтын дугаар" : "Meeting Number" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Төлөв" : "Status" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Уулзалтын өдөр, цаг" : "Meeting date & time" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Уулзах хүсэлт илгээсэн" : "Sender" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Уулзах хүсэлт авсан" : "Receiver" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Уулзалтын тухай" : "Description" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Уулзалтын өрөө" : "Meeting room" }}
          </th>
          <th class="p-2 text-center">
            {{ lang === "mn" ? "Үүсгэсэн огноо" : "Created Date" }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(meeting, index) in allMeetings"
          :key="meeting.id"
          class="border-b border-gray-300"
        >
          <td class="p-2 text-center">{{ index + 1 }}</td>
          <td class="p-2 text-center">
            <div class="flex justify-center items-center gap-2 text-center">
              <button
                @click="viewDetail(meeting)"
                class="bg-blue-500 hover:bg-blue-600 text-white py-1 px-2 rounded"
              >
                {{ lang === "mn" ? "Дэлгэрэнгүй" : "View Details" }}
              </button>
            </div>
          </td>
          <td class="p-2 text-center">
            {{ meeting.meeting_number }}
          </td>
          <td
            class="p-2 text-center"
            :class="{
              'text-green font-semibold':
                meeting?.meeting_status === 'accepted',
              'text-red-600 font-semibold':
                meeting?.meeting_status === 'cancelled',
              'text-yellow-600 font-semibold':
                meeting?.meeting_status === 'pending',
            }"
          >
            {{
              meeting.meeting_status === "accepted"
                ? lang === "mn"
                  ? "Зөвшөөрсөн"
                  : "Accepted"
                : meeting.meeting_status === "cancelled"
                ? lang === "mn"
                  ? "Цуцлагдсан"
                  : "Cancelled"
                : lang === "mn"
                ? "Хүлээгдэж байна"
                : "Pending"
            }}
          </td>

          <td class="p-2 text-center">
            {{ meeting.meeting_date }}
            {{ meeting.meeting_time.slice(0, 5) }}
          </td>
          <td class="p-2 text-center">
            {{ lang === "mn" ? meeting.sender_name : meeting.sender_name_en }}
          </td>
          <td class="p-2 text-center">
            {{
              lang === "mn" ? meeting.receiver_name : meeting.receiver_name_en
            }}
          </td>
          <td class="p-2 text-center">
            {{ meeting.meeting_description }}
          </td>
          <td class="flex flex-col gap-2 p-2">
            <span
              >{{ lang === "mn" ? "Өрөөний №:" : "Room №:" }}
              {{ meeting.room_number }}</span
            >
            <span
              >{{ lang === "mn" ? "Багтаамж:" : "Capacity:" }}
              {{ meeting.capacity }}</span
            >
          </td>
          <td class="p-2 text-center">
            {{ meeting.created_at }}
          </td>
        </tr>
      </tbody>
    </table>
  </section>

  <div v-else class="flex justify-center items-center w-full h-[20vh]">
    <BarLoading />
  </div>

  <YellowMeetingDetail
    v-if="isDetail && selectedMeeting"
    :selectedMeeting="selectedMeeting"
    @closeDetail="closeDetail"
  />
  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import ErrorModal from "@/components/ui/ErrorModal.vue";
import YellowMeetingDetail from "../YellowMeetingDetail.vue";
import BarLoading from "@/components/ui/BarLoading.vue";

export default {
  name: "YellowMeetingList",
  props: {
    meetings: Array,
  },
  components: {
    ErrorModal,
    YellowMeetingDetail,
    BarLoading,
  },
  setup(props) {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const allMeetings = ref(props.meetings);
    const error = ref(null);
    const isLoading = ref(false);

    const isDetail = ref(false);
    const selectedMeeting = ref(null);
    const viewDetail = (meeting) => {
      selectedMeeting.value = meeting;
      isDetail.value = !isDetail.value;
    };

    const closeDetail = () => {
      selectedMeeting.value = null;
      isDetail.value = !isDetail.value;
    };

    return {
      lang,
      allMeetings,
      error,
      isDetail,
      viewDetail,
      selectedMeeting,
      closeDetail,
      isLoading,
    };
  },
};
</script>
